import { formatCompact, formatCount, formatPercent } from '@/shared/analytics/MetricFormatting';
import type { SignalValueFormat } from './SignalTypes';

const usdCompact = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1,
});

/** Formats a numeric value for display per a {@link SignalValueFormat}. `percent` expects a fraction in [0,1]. */
export function formatSignalValue(format: SignalValueFormat | undefined, value: number): string {
    switch (format) {
        case 'percent':
            return formatPercent(value, 0);
        case 'currency':
            return usdCompact.format(value);
        case 'compact':
            return formatCompact(value);
        case 'days':
            return `${Math.round(value)}d`;
        case 'ratio':
            return `${value.toFixed(1)}×`;
        case 'count':
        case 'raw':
        default:
            return formatCount(value);
    }
}
